import { Box, Button, Flex, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { TextSerif } from "@/components/elements";
import { paths } from "@/config/paths";
import { useNotifications } from "@/services/notifications/get-notifications";
import { useUpdateNotificationStatus } from "@/services/notifications/update-notification-status";
import { useUpdateOnboarding } from "@/services/profile/update-onboarding-profile";
import { useUpdateWalkthroughCompleted } from "@/services/profile/update-walkthrough-completed";

import type { FC } from "react";

export const UserProfileTabAdmin: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const walkthroughResetMutation = useUpdateWalkthroughCompleted();
  const { mutate: updateNotificationStatus, isPending: isUpdatingNotifications } =
    useUpdateNotificationStatus();

  const { data: notificationsResponse } = useNotifications({
    page: 1,
    pageSize: 100,
  });

  function resetNotifications() {
    notificationsResponse?.results
      .filter((notification) => notification.status === "read")
      .forEach((notification) => {
        updateNotificationStatus({
          id: notification.id,
          status: "delivered",
        });
      });
  }

  const onboardingResetMutation = useUpdateOnboarding({
    mutationConfig: {
      onSuccess: () => {
        navigate(paths.plans.root.getHref());
      },
    },
  });

  return (
    <Stack gap="lg">
      <Box p="md">
        <Title order={3} fw="normal" fz="1.25em" pb="md">
          {t("admin.title")}
        </Title>

        <TextSerif fz="md">{t("admin.description")}</TextSerif>
      </Box>

      <Flex p="md" gap="lg" wrap="wrap" justify="flex-start">
        <Button
          maw={200}
          loading={walkthroughResetMutation.isPending}
          onClick={() => walkthroughResetMutation.mutate({ walkthrough_completed: false })}
        >
          {t("admin.resetWalkthrough")}
        </Button>

        <Button maw={200} loading={isUpdatingNotifications} onClick={resetNotifications}>
          {t("admin.resetNotifications")}
        </Button>

        <Button
          maw={200}
          loading={onboardingResetMutation.isPending}
          onClick={() =>
            onboardingResetMutation.mutate({
              additional_info: {
                walkthrough_completed: true,
                onboarding_completed: false,
                onboarding: undefined,
              },
            })
          }
        >
          {t("admin.resetOnBoarding")}
        </Button>
      </Flex>
    </Stack>
  );
};
